<template>
  <div class="analytics">
    <div class="comments-list-wrap">
      <ul class="comments-header">
        <li class="comments-header__item">
          <span class="comments-header__item-title">{{$t('feed.commentsList.dateFrom')}}</span>
          <el-date-picker
            v-model="date_from"
            type="date"
            format="dd.MM.yyyy"
            placeholder="Выберите дату">
          </el-date-picker>
        </li>
        <li class="comments-header__item">
          <span class="comments-header__item-title">{{$t('feed.commentsList.dateTo')}}</span>
          <el-date-picker
            v-model="date_to"
            type="date"
            format="dd.MM.yyyy"
            placeholder="Выберите дату">
          </el-date-picker>
        </li>
        <li class="comments-header__item">
          <span class="comments-header__item-title">{{$t('feed.commentsList.sort')}}</span>
          <el-select v-model="sort" placeholder="Сортировка">
            <el-option
              v-for="item in sortOptions"
              :key="item.label"
              :label="item.label"
              :value="item.label">
            </el-option>
          </el-select>
        </li>
        <li class="comments-header__item">
          <span class="comments-header__item-title">Поиск</span>
          <el-input v-model="searchModel" :class="inputClass" placeholder="Поиск">
        </el-input>
        </li>
      </ul>
    </div>
    <el-divider></el-divider>
    <div class="comments-list" v-loading="loading">
      <el-card class="box-card comments-list__card" shadow="hover" v-for="comment in comments" :key="comment.id">
        <div slot="header" class="clearfix">
          <comment-list-header :comment="comment" />
        </div>
        <comment-list-body :comment="comment" @setTrust="setTrust" @setPostTrust="setPostTrust" @showMore="showMore"/>
      </el-card>
    </div>
    <el-divider></el-divider>
    <div class="button-wrap" v-if="comments.length < count">
      <el-button type="primary" :disabled="loading" @click="getComments">Показать еще</el-button>
    </div>
  </div>
</template>

<script>
  // library
  import moment from 'moment';

  // api
  import { getAllComments, setCommentTrustApi, setPostsTrustApi } from "../../../../../../api/publications";

  // components
  import CommentListHeader from './CommentListHeader';
  import CommentListBody from './CommentListBody';

  export default {
    name: "CommentsList",
    props: {
      active: {
        type: Boolean,
      },
    },
    data() {
      let getDateFrom = () => {
        let d = new Date();
        let year = d.getFullYear();
        let month = d.getMonth();
        let day = d.getDate();

        return  new Date(year, month, day);
      };

      return {
        loading: false,
        loadComments: true,
        comments: [],
        date_from: getDateFrom(),
        date_to: new Date(),
        sortOptions: this.$t('feed.commentsList.sortOptions'),
        searchModel: '',
        sort: this.$t('feed.commentsList.defaultSort'),
        format: 'YYYY-MM-DD HH:mm:ss',
        limit: 20,
        start: 0,
        count: 0
      };
    },
    methods: {
      showMore(post) {
        post.showMore = !post.showMore;
      },
      setPostTrust(params) {
        setPostsTrustApi(params).then(() => {
          this.comments = this.comments.map(item => {
            if (item.post.id === params.post_id) {
              item.post.trust.trust = params.trust;
            }

            return item;
          });
        });
      },
      setTrust({commentId, postId, trust, owner_id, network_id}) {
        const params = {
          comment_id: commentId,
          post_id: postId,
          owner_id,
          network_id,
          trust: trust
        };

        setCommentTrustApi(params).then(() => {
          this.comments = this.comments.map(item => {
            if (item.id === commentId) {
              item.trust_coment = trust;
            }

            return item;
          });
        });
      },
      loadMoreComments() {
        if (this.loadComments) {
          this.getComments();
        }
      },
      getComments() {
        this.loading = true;

        let params = {
          thread_id: this.$route.params.threadId,
          from: moment(this.date_from).format(this.format),
          to: moment(this.date_to).format(this.format),
          limit: this.limit,
          start: this.start,
          sort: this.sortOptions.find(item => item.label === this.sort).value,
          filter: {
            search: this.searchModel,
          },
        };


        getAllComments(params).then(resp => {
          console.log(resp.data);
          resp.data.commentaries = resp.data.commentaries.map(item => {
            item.post = Object.assign({}, item.post, { showMore: false });
            return item;
          });

          this.comments = [...this.comments, ...resp.data.commentaries];
          this.start = this.comments.length;
          this.count = resp.data.count;

          if (this.start >= Number(resp.data.count)){
            this.loadComments = false;
          }

          this.loading = false;
        });
      },
      reloadComments() {
        this.comments = [];
        this.start = 0;
        this.getComments();
      },
    },
    watch: {
      active(value) {
        if (value) {
          if (!this.comments.length) {
            this.getComments();
          }
        }
      },
      date_to() {
        this.reloadComments();
      },
      date_from() {
        this.reloadComments();
      },
      searchModel() {
        this.reloadComments();
      },
      sort() {
        this.reloadComments();
      }
    },
    components: {
      CommentListHeader,
      CommentListBody,
    },
  };
</script>

<style>
  .comments-wrap {

  }
  .comments-header {
    display: flex;
    padding: 0;
    margin: 0;
    list-style: none;
  }
  .comments-header__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 15px;
  }
  .comments-header__item-title {
    margin-bottom: 10px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 14px;
  }
  .comments-list {
    min-height: 50px;
  }
  .comments-list__card {
    margin-bottom: 20px;
  }
  .button-wrap {
    display: flex;
    justify-content: center;
  }
  @media screen and (max-width: 480px) {
    .comments-header {
      flex-direction: column;
      align-items: flex-start;
    }
    .comments-header__item {
      margin-bottom: 10px;
    }

    .comments-header__item:last-child {
      margin-bottom: 0;
    }
  }
</style>
